<ssc-contact-overlay
  *ngIf="showContactButton"
  (overlayClosed)="showContactOverlay = false"
  [showOverlay]="showContactOverlay"
>
  <dap-lib-button
    (click)="showContactOverlay = true"
    buttonSize="mediumtight"
    class="shrink"
    iconName="support"
    iconPosition="left"
    iconSize="20"
    variant="violet"
    data-analytics="footer_contact"
    >{{ 'FOOTER.CONTACT' | translate }}
  </dap-lib-button>
</ssc-contact-overlay>
